import { render, staticRenderFns } from "./Twitter.vue?vue&type=template&id=2612780a&"
import script from "./Twitter.vue?vue&type=script&lang=ts&"
export * from "./Twitter.vue?vue&type=script&lang=ts&"
import style0 from "./Twitter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports